import React, { useContext } from 'react'
import { View, Text, StyleSheet, Pressable } from 'react-native'
import {
  BG_STYLES,
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  CrossIcon,
  LazyImage,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'

import { ResponsiveContext } from 'app/context/ResponsiveUIContext'
import { DIMENSION_WIDTH } from 'app/utils/common'

interface Props {
  farmIndex: number
  farmImage: string
  farmName: string
  land: string
  latLng: string
  reportUrl: string | null
  cropImage: string | null
  onSelect: () => void
  isSelected: boolean
  onRemove: () => void
}

const FarmCard = ({
  farmIndex,
  farmImage,
  farmName,
  onSelect,
  isSelected,
  onRemove,
}: Props) => {
  const { mediaStyles } = useContext(ResponsiveContext)

  return (
    <Pressable
      style={({ pressed }) => [
        BG_STYLES.bgWhite,
        COMMON_STYLES.br1,
        COMMON_STYLES.ofHidden,
        COMMON_STYLES.relative,
        styles['b3/2'],
        styles.card,
        farmIndex !== 0 && COMMON_STYLES.ml1,
        isSelected
          ? [BORDER_STYLES.borderPrimary100]
          : BORDER_STYLES.borderBlue20,
        mediaStyles({
          mobileStyle: {
            width: DIMENSION_WIDTH - 96,
            minWidth: styles.card.width,
          },
        }),
        pressed && COMMON_STYLES['opacity1/2'],
      ]}
      onPress={onSelect}
    >
      <View style={[styles.header, COMMON_STYLES.relative]}>
        <LazyImage
          imageUrl={farmImage}
          imgStyles={[
            COMMON_STYLES.fullHeight,
            COMMON_STYLES.fullWidth,
            COMMON_STYLES['br1/2'],
          ]}
          fallBackIcon={<></>}
        />

        <View
          style={[
            COMMON_STYLES.absolute,
            BG_STYLES.bgBlack,
            COMMON_STYLES['opacity1/2'],
            COMMON_STYLES['ph1/2'],
            COMMON_STYLES['pv1/4'],
            styles.farmCountLabel,
          ]}
        >
          <Text
            style={[
              TYPOGRAPHY.TEXT2,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textWhite,
            ]}
          >
            Farm {farmIndex + 1}
          </Text>
        </View>
      </View>

      <View style={[COMMON_STYLES.ph1, COMMON_STYLES.pb1]}>
        <Text
          style={[
            TYPOGRAPHY.TEXT1,
            VARIANTS_STYLES.SEMI_EMPHASIZED,
            TEXT_STYLES.textNeutral80,
          ]}
        >
          {farmName}
        </Text>
      </View>
      {isSelected && (
        <Pressable
          style={({ pressed }) => [
            pressed && COMMON_STYLES['opacity1/2'],
            styles.crossIcon,
          ]}
          onPress={onRemove}
        >
          <CrossIcon height={16} width={16} strokeColor={'white'} />
        </Pressable>
      )}
    </Pressable>
  )
}

const styles = StyleSheet.create({
  card: {
    width: 292,
  },
  header: {
    height: 171,
    margin: 8,
  },
  cropImage: {
    height: 48,
    width: 48,
    borderRadius: 24,
    bottom: -24,
    right: 16,
    borderWidth: 1,
    borderColor: COLORS.neutral10,
  },
  farmCountLabel: {
    borderTopLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  crossIcon: {
    position: 'absolute',
    top: 4,
    right: 4,
    zIndex: 1,
    padding: 5,
    borderRadius: 9999,
    backgroundColor: COLORS.primary100,
    borderWidth: 2,
    borderColor: COLORS.white,
  },
  'b3/2': {
    borderWidth: 1.5,
  },
})

export default FarmCard
